import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Link } from "react-router-dom";
import { Queries, Mutations } from "../../../../../graphql";
import PropTypes from "prop-types";
import {
  Tabs,
  Typography,
  Spin,
  Row,
  Col,
  Input,
  message,
  Table,
  Icon,
  Button,
  Popconfirm,
  Form,
  Select,
  Radio,
  DatePicker,
  Avatar,
  Modal,
  InputNumber,
  TimePicker,
} from "antd";
import moment from "moment";
import FromInput from "../../../../../components/user/from/Input";
import detail from "../../../Hospital/Withdraw/detail";
import { checkLinkURL } from "../../../../../utils/auth";
import { alertMessage } from "../../../../../utils/message";
import {
  changeFormatdate,
  changeFormatFulldate,
} from "../../../../../utils/formatdate";
//import ModalConfirmForm from "../../../../../components/user/ModalConfirmForm";

// import {
//    LoadingOutlined,
//    DeleteOutlined,
//    EyeOutlined,
//    FilePdfOutlined,
//    EllipsisOutlined
// } from '@ant-design/icons';

const { TabPane } = Tabs;
const { Text, Title } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const YEAR_TYPE = [
  { label: "2565", value: "2565" },
  { label: "2566", value: "2566" },
  { label: "2567", value: "2567" },
  { label: "2568", value: "2568" },
  { label: "2569", value: "2569" },
];

const newsDataProfile = "";
const format = "HH:mm";

class Tab4 extends Component {
  state = {
    dataTalbeUploads: [
      // {
      //   studyLearnTerm: "",
      //   studyLearnYear: "",
      //   studyLearnGrade: null,
      //   studyLearnGPAX: null,
      //   createdAt: null,
      //   studyLearnRemark: "",
      //   file: [],
      // },
    ],
    columns: [
      {
        title: "ปีการศึกษา",
        dataIndex: "studyLearnYear",
        vertical: "top",
        width: "150px",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              <Form.Item style={{ marginBottom: "0px" }} hidden>
                {this.props.propFormInput.getFieldDecorator(
                  "isValidate" + index,
                  {
                    initialValue: item ? item : null,
                    
                  }
                )(<Input />)}
              </Form.Item>
              {/* {this.props.detailForm?.studyLearnRecord[index]?.studyLearnYear ?
                      this.props.detailForm?.studyLearnRecord[index]?.studyLearnYear : ""} */}
              <Form.Item style={{ marginBottom: "0px" }}>
                {this.props.propFormInput.getFieldDecorator(
                  "studyLearnYear" + index,
                  {
                    initialValue: item ? item : [],
                    rules: [
                      {
                        // required:
                        //   record.studyLearnTerm ||
                        //   record.studyLearnGrade ||
                        //   record.studyLearnGPAX ||
                        //   //record.createdAt ||
                        //   record.studyLearnRemark ||
                        //   record.file
                        //     ? true
                        //     : false,
                        required: true,
                        message: "กรุณาระบุปีการศึกษา",
                      },
                    ],
                  }
                )(
                   <Input
                    // defaultValue={item}
                    // style={{ width: "150px" }}
                   disabled={
                      record.studyLearnRecordId
                        ? true
                        : record.disabledRow
                        ? true
                        : false
                    }
                    onBlur={(e) =>
                      this.onChangeValueForm(index, e, "studyLearnYear")
                    }
                    onKeyPress={(event) => {
                  if (event && !/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                  />
                  // <Select
                  //   style={{ width: "100%" }}
                  //   // onChange={ (e) => this.onChangeValueForm(index, e, 'documentType') }
                  //   disabled={
                  //     record.studyLearnRecordId
                  //       ? true
                  //       : record.disabledRow
                  //       ? true
                  //       : false
                  //   }
                  //   showSearch
                  //   placeholder="กรุณาเลือก ปีการศึกษา"
                  //   optionFilterProp="children"
                  //   onChange={(value) =>
                  //     this.onChangeValueForm(index, value, "studyLearnYear")
                  //   }
                  // >
                  //   {console.log(
                  //     "dropDownYear select",
                  //     this.props.dropDownYear
                  //   )}
                  //   {this.props.dropDownYear.map((valuesLabel, keys) => {
                  //     return (
                  //       <Option value={valuesLabel.value}>
                  //         {valuesLabel.label}
                  //       </Option>
                  //     );
                  //   })}
                  // </Select>
                )}
              </Form.Item>{" "}
            </>
          );
        },
      },
      {
        title: "ภาคการศึกษาที่",
        dataIndex: "studyLearnTerm",
        align: "center",
        vertical: "top",
        width: "150px",
        render: (item, record, index) => {
          return (
            <>
              {/* {this.props.detailForm?.studyLearnRecord[index]?.studyFileName ?  */}
              {/* : ""} */}

              <Form.Item style={{ marginBottom: "0px" }}>
                {this.props.propFormInput.getFieldDecorator(
                  "studyLearnTerm" + index,
                  {
                    initialValue: item ? item : null,
                    rules: [
                      {
                        // required:
                        //   record.studyLearnYear ||
                        //   record.studyLearnGrade ||
                        //   record.studyLearnGPAX ||
                        //   //record.createdAt ||
                        //   record.studyLearnRemark ||
                        //   record.file
                        //     ? true
                        //     : false,
                        required: true,
                        message: "กรุณาระบุภาคการศึกษาที่",
                      },
                    ],
                  }
                )(
                  <Input
                    // defaultValue={item}
                    // style={{ width: "150px" }}
                    disabled={
                      record.studyLearnRecordId
                        ? true
                        : record.disabledRow
                        ? true
                        : false
                    }
                    onBlur={(e) =>
                      this.onChangeValueForm(index, e, "studyLearnTerm")
                    }
                  />
                )}
              </Form.Item>
            </>
          );
        },
      },

      {
        title: "เกรดเฉลี่ย (GPA) / ผลการศึกษา",
        dataIndex: "studyLearnGrade",
        width: "200px",
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {/* {this.props.detailForm?.studyLearnRecord[index]?.studyLearnGrade ? this.props.detailForm?.studyLearnRecord[index]?.studyLearnGrade : ""} */}
              <Form.Item label={""} style={{ marginBottom: "0px" }}>
                {this.props.propFormInput.getFieldDecorator(
                  "studyLearnGrade" + index,
                  {
                    initialValue: item ? item : null,
                    rules: [
                      {
                        // required:
                        //   record.studyLearnTerm ||
                        //   record.studyLearnYear ||
                        //   record.studyLearnGPAX ||
                        //   // record.createdAt ||
                        //   record.studyLearnRemark ||
                        //   record.file
                        //     ? true
                        //     : false,
                        required: true,
                        message: "กรุณาระบุเกรดเฉลี่ย (GPA) / ผลการศึกษา",
                      },
                    ],
                  }
                )(
                  <Input
                    // defaultValue={item}
                    disabled={
                      record.studyLearnRecordId
                        ? true
                        : record.disabledRow
                        ? true
                        : false
                    }
                    onBlur={(e) =>
                      this.onChangeValueForm(index, e, "studyLearnGrade")
                    }
                  />
                )}
              </Form.Item>
            </>
          );
        },
      },
      {
        title: "เกรดเฉลี่ยสะสม (GPAX) / ผลการศึกษา",
        dataIndex: "studyLearnGPAX",
        width: "200px",
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {/* {this.props.detailForm?.studyLearnRecord[index]?.studyLearnGrade ? this.props.detailForm?.studyLearnRecord[index]?.studyLearnGrade : ""} */}
              <Form.Item label={""} style={{ marginBottom: "0px" }}>
                {this.props.propFormInput.getFieldDecorator(
                  "studyLearnGPAX" + index,
                  {
                    initialValue: item ? item : null,
                    rules: [
                      {
                        // required:
                        //   record.studyLearnTerm ||
                        //   record.studyLearnYear ||
                        //   record.studyLearnGrade ||
                        //   //record.createdAt ||
                        //   record.studyLearnRemark ||
                        //   record.file
                        //     ? true
                        //     : false,
                        required: true,
                        message: "กรุณาระบุเกรดเฉลี่ยสะสม (GPAX) / ผลการศึกษา",
                      },
                    ],
                  }
                )(
                  <Input
                    // defaultValue={item}
                    disabled={
                      record.studyLearnRecordId
                        ? true
                        : record.disabledRow
                        ? true
                        : false
                    }
                    onBlur={(e) =>
                      this.onChangeValueForm(index, e, "studyLearnGPAX")
                    }
                  />
                )}
              </Form.Item>
            </>
          );
        },
      },
      // {
      //   title: "วันที่แจ้ง",
      //   dataIndex: "createdAt",
      //   width: "200px",
      //   vertical: "top",
      //   align: "center",
      //   render: (item, record, index) => {
      //     return (
      //       <>
      //         {/* {this.props.detailForm?.studyLearnRecord[index]?.createdAt ?
      //                <span>{moment(this.props.detailForm?.studyLearnRecord[index]?.createdAt ).format('YYYY-MM-DD')}</span>
      //              // " dsd"
      //                : ""} */}
      //         <Form.Item className="mb-1">
      //           {this.props.propFormInput.getFieldDecorator("createdAt" + index, {
      //              initialValue: item ? moment(item) : null,
      //             rules: [
      //               {
      //                 required:
      //                   record.studyLearnTerm ||
      //                   record.studyLearnYear ||
      //                   record.studyLearnGrade ||
      //                   record.studyLearnRemark ||
      //                   record.studyLearnGPAX ||
      //                   record.file
      //                     ? true
      //                     : false,
      //                 message: "กรุณาระบุรายละเอียด",
      //               },
      //             ],
      //           })(
      //             <DatePicker
      //               format={this.dateFormatNumber("createdAt")}
      //               placeholder=""
      //               style={{ width: "100%" }}
      //               disabled={false}
      //               name="createdAt"
      //               onChange={(e) =>
      //                 this.onChangeValueForm(index, e, "createdAt")
      //               }
      //             />
      //           )}
      //         </Form.Item>
      //       </>
      //     );
      //   },
      // },
      {
        title: "เอกสารแนบ",
        dataIndex: "file",
        width: "200px",
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {record.studyLearnRecordId && record?.studyFilePath
                ? this.showMoreFileUploads(index, record)
                : record.studyLearnRecordId && !record?.studyFilePath ?
                '-'
                : this.inputFormUploads(index, record)}
            </>
          );
        },
      },
      {
        title: "หมายเหตุ",
        dataIndex: "studyLearnRemark",
        width: "30%",
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {/* {this.props.detailForm?.studyLearnRecord[index]?.studyLearnRemark ? this.props.detailForm?.studyLearnRecord[index]?.studyLearnRemark : ""} */}
              <Form.Item label={""} style={{ marginBottom: "0px" }}>
                {this.props.propFormInput.getFieldDecorator(
                  "studyLearnRemark" + index,
                  {
                    initialValue: item ? item : "",
                  }
                )(
                  <Input
                    // defaultValue={item}
                    disabled={record.studyLearnRecordId ? true  : record.disabledRow
                      ? true: false}
                    onBlur={(e) =>
                      this.onChangeValueForm(index, e, "studyLearnRemark")
                    }
                  />
                )}
              </Form.Item>
            </>
          );
        },
      },
      {
        title: "สถานะการตรวจสอบเอกสาร",
        dataIndex: "studyLearnReview",
        width: "200px",
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {/* {this.props.detailForm?.studyLearnRecord[index]?.studyLearnRemark ? this.props.detailForm?.studyLearnRecord[index]?.studyLearnRemark : ""} */}
              
              <Input
                  defaultValue={record.studyLearnReviewName ? record.studyLearnReviewName : "รอตรวจสอบเอกสาร"}
                  disabled={true}
                  // onBlur={(e) =>
                  //   this.onChangeValueForm(index, e, "studyLearnReviewAt")
                  // }
                />

              <Form.Item label={""} style={{ marginBottom: "0px" }} hidden>
                {this.props.propFormInput.getFieldDecorator(
                  "studyLearnReview" + index,
                  {
                    initialValue: item ? item : "pending_review",
                  }
                )(
                  <Input
                    // defaultValue={item}
                    disabled={true}
                    onBlur={(e) =>
                      this.onChangeValueForm(index, e, "studyLearnReview")
                    }
                  />
                )}
              </Form.Item>
              <Form.Item label={""} style={{ marginBottom: "0px" }} hidden>
                {this.props.propFormInput.getFieldDecorator(
                  "studyLearnReviewBy" + index,
                  {
                    initialValue: item ? item : "-",
                  }
                )(
                  <Input
                    // defaultValue={item}
                    disabled={true}
                    onBlur={(e) =>
                      this.onChangeValueForm(index, e, "studyLearnReviewBy")
                    }
                  />
                )}
              </Form.Item>
              {/* <Form.Item label={""} style={{ marginBottom: "0px" }} hidden>
                {this.props.propFormInput.getFieldDecorator(
                  "studyLearnReviewRemark" + index,
                  {
                    initialValue: item ? item : null,
                  }
                )(
                  <Input
                    // defaultValue={item}
                    disabled={true}
                    onBlur={(e) =>
                      this.onChangeValueForm(index, e, "studyLearnReviewRemark")
                    }
                  />
                )}
              </Form.Item> */}
            </>
          );
        },
      },
      {
        title: "วันที่ตรวจสอบเอกสาร",
        dataIndex: "studyLearnReviewAt",
        width: "200px",
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {/* {this.props.detailForm?.studyLearnRecord[index]?.studyLearnRemark ? this.props.detailForm?.studyLearnRecord[index]?.studyLearnRemark : ""} */}
              
              <Input
                  defaultValue={item ? changeFormatdate(item) : "-"}
                  disabled={true}
                  // onBlur={(e) =>
                  //   this.onChangeValueForm(index, e, "studyLearnReviewAt")
                  // }
                />
              <Form.Item label={""} style={{ marginBottom: "0px" }} hidden>
                {this.props.propFormInput.getFieldDecorator(
                  "studyLearnReviewAt" + index,
                  {
                    initialValue: item ? item : null,
                  }
                )(
                  <Input
                  // defaultValue={item}
                  disabled={true}
                  // onBlur={(e) =>
                  //   this.onChangeValueForm(index, e, "studyLearnReviewAt")
                  // }
                />
                )}
              </Form.Item>
            </>
          );
        },
      },
   
      {
        title: "สาเหตุที่ไม่ผ่านการศึกษา",
        dataIndex: "studyLearnReviewRemark",
        width: "200px",
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {/* {this.props.detailForm?.studyLearnRecord[index]?.studyLearnRemark ? this.props.detailForm?.studyLearnRecord[index]?.studyLearnRemark : ""} */}
              
             <Form.Item label={""} style={{ marginBottom: "0px" }} >
                {this.props.propFormInput.getFieldDecorator(
                  "studyLearnReviewRemark" + index,
                  {
                    initialValue: item ? item : null,
                  }
                )(
                  <Input
                    // defaultValue={item}
                    disabled={true}
                    // onBlur={(e) =>
                    //   this.onChangeValueForm(index, e, "studyLearnReviewRemark")
                    // }
                  />
                )}
              </Form.Item>
            </>
          );
        },
      },
      {
        title: "การจัดการ",
        dataIndex: "5",
        width: 150,
        align: "center",
        render: (item, record, index) => {
          return this.showDetailBtnInput(
            record,
            index,
            record.studyLearnRecordId ? record.studyLearnRecordId : null
          );
        },
      },
    ],
    dataTalbeLength: 1,
    preLoadOnsubmit: false,
    loading: true,
    delectStudyLearnRecordId: [],
  };

  showDetailBtnInput = (record, arrayId, studyLearnRecordId = null) => {
    const { dataTalbeUploads } = this.state;
    const { detailForm } = this.props;
    return (
      <>
        {console.log("record Showdetail", record)}

        {studyLearnRecordId ? (
          <Avatar
            shape="square"
            icon={<Icon type="delete" />}
            className="mr-1 mb-1 bg-red"
            onClick={() =>
              record.studyLearnReview !== 'pending_review' ? "" :
              studyLearnRecordId
                ? // this.destroyArrayDataUploads(arrayId, studyLearnRecordId)
                  this.showModalFormConfirm(
                    record,
                    "ท่านต้องการลบข้อมูล?",
                    "",
                    "ยืนยัน",
                    arrayId,
                    studyLearnRecordId
                  )
                : this.destroyArrayDataUploads(arrayId, studyLearnRecordId)
            }
            // disabled={true}
            style={{ cursor: `${record.studyLearnReview !== 'pending_review' ? 'no-drop' : 'pointer'}`, background: `${record.studyLearnReview !== 'pending_review' ? '#b6b6b6' : 'red'}` }}
          />
        ) : (
          <div className="flex">
            {record.isShowEditButton && (
              <Avatar
                shape="square"
                icon={<Icon type="edit" />}
                className="mr-2 mb-1"
                style={{ cursor: "pointer", backgroundColor: "#36699E" }}
                onClick={() =>
                  record.isNew && this.enableToEdit(arrayId, record)
                }
              />
            )}
            {record.isShowSaveButton && (
              <Avatar
                shape="square"
                icon={<Icon type="save" />}
                className="mr-2 mb-1"
                style={{ cursor: "pointer", backgroundColor: "#36699E" }}
                onClick={() => record.isNew && this.checkBeforeAddRow(arrayId)}
              />
            )}

            <Avatar
              shape="square"
              icon={<Icon type="delete" />}
              className="mr-1 mb-1 bg-red"
              onClick={() =>
                studyLearnRecordId
                  ? // this.destroyArrayDataUploads(arrayId, studyLearnRecordId)
                    this.showModalFormConfirm(
                      record,
                      "ท่านต้องการลบข้อมูล?",
                      "",
                      "ยืนยัน",
                      arrayId,
                      studyLearnRecordId
                    )
                  : this.destroyArrayDataUploads(arrayId, studyLearnRecordId)
              }
              style={{ cursor: "pointer", background: "red" }}
            />
          </div>
        )}
        {/* ) : (
          <Avatar
            shape="square"
            icon={<Icon type="delete" />}
            className="mr-1 mb-1 bg-red"
            onClick={() =>
              //this.destroyArrayDataUploads(arrayId, studyLearnRecordId)
              this.showModalFormConfirm(
                record,
                "ท่านต้องการลบข้อมูล?",
                "",
                "ยืนยัน",
                arrayId,
                studyLearnRecordId
              )
            }
            style={{ cursor: "not-allowed" }}
            disabled={true}
          />
        )} */}
      </>
    );
  };
  showModalFormConfirm = async (
    values,
    messageShow,
    title,
    textBtnOK,
    arrayId,
    studyLearnRecordId
  ) => {
    const { form, client } = this.props;

    console.log("showmodalconfirm destroyArrayId", arrayId);
    console.log(
      "showmodalconfirm destroystudyLearnRecordId",
      studyLearnRecordId
    );

    await this.setState({
      destroyArrayId: arrayId,
      destroyStudyLearnRecordId: studyLearnRecordId,
      // ModalConfirmFormTitle: messageShow,
      // ModalConfirmFormSubTitle: title,
      ModalConfirmFormShowModal: true,
      // ModalConfirmFormBtnOk: textBtnOK,
      // ModalConfirmFormBtnCancel: "ยกเลิก",
      // ModalConfirmFormValue: values,
      //ModalConfirmFormSubmitToSend: this.destroyArrayDataUploads(arrayId, studyLearnRecordId)
    });
  };

  hideModalConfirm = async () => {
    console.log("hidemodal");
    await this.setState({
      ModalConfirmFormTitle: null,
      ModalConfirmFormSubTitle: null,
      ModalConfirmFormShowModal: false,
      ModalConfirmFormBtnOk: null,
      ModalConfirmFormBtnCancel: null,
      ModalConfirmFormValue: null,
      ModalConfirmFormSubmitToSend: null,
    });
  };

  dateFormatNumber = (values) => {
    let valueReturn = this.props.form.getFieldValue(values);
    return changeFormatdate(moment(valueReturn));
  };

  inputFormUploads = (arrayId, record) => {
    const { dataTalbeUploads } = this.state;
    let fileName = dataTalbeUploads[arrayId].file
      ? dataTalbeUploads[arrayId].file.name
      : "";
    console.log("record", record);
    console.log("inputFormUploads", +arrayId);
    console.log("inputFormUploads file", dataTalbeUploads[arrayId]);
    return (
      <>
        {record.fileId ? (
          record.file && (
            <Text
              onClick={() => {
                this.modalShowFileDatabase(record, "เอกสาร");
              }}
              style={{ cursor: "pointer" }}
              className="btn-show-fileuploads"
            >
              ดูไฟล์อัปโหลด
              {console.log("inputFormUploads case1")}
            </Text>
          )
        ) : (
          <>
            {console.log("inputFormUploads case2 array:" + arrayId)}
            {console.log("disableRoww upload", record.disabledRow)}

            <Form.Item label={""} style={{ marginBottom: "0px" }}>
              {this.props.propFormInput.getFieldDecorator("file" + arrayId, {
                //initialValue: item ? item : null,
                // rules: [
                //   {
                //     required: true,
                //     //message: "กรุณาอัพโหลดไฟล์",
                //     className: "height-input-menu",
                //     valuePropName: "fileList",
                //   },
                // ],
              })(
                <>
                  {!record.disabledRow ? (
                    <label
                      for={"input-file-" + arrayId}
                      class="custom-file-upload"
                      style={{ lineHeight: 1.5 }}
                    >
                      <p
                        className="py-2 px-4 mb-0"
                        align={"center"}
                        style={{ backgroundColor: "#8d0e14", color: "#fff" }}
                      >
                        อัปโหลด
                      </p>
                      <p style={{ fontSize: "12px" }} className="my-2">
                        แนบไฟล์ที่เป็นนามสกุล<br></br> .jpg, .png หรือ .pdf
                      </p>
                    </label>
                  ) : (
                    <label style={{ lineHeight: 1.5 }}>
                      <p
                        className="py-2 px-4 mb-0"
                        align={"center"}
                        style={{ backgroundColor: "#E3E3E3", color: "#fff" }}
                      >
                        อัปโหลด
                      </p>
                      <p style={{ fontSize: "12px" }} className="my-2">
                        แนบไฟล์ที่เป็นนามสกุล<br></br> .jpg, .png หรือ .pdf
                      </p>
                    </label>
                  )}
                  {/* <p
                    className={fileName ? "" : "color-red"}
                    style={{ lineHeight: 1.2 }}
                  >
                    {!fileName && (
                      <p id={"showTextUplodas" + arrayId}>
                        กรุณาเลือก อัปโหลดรูปภาพหรือไฟล์
                      </p>
                    )}
                  </p> */}
                  <input
                    id={"input-file-" + arrayId}
                    className="input-file"
                    // name={uploadName}
                    type="file"
                    accept="file_extension"
                    accept="image/png, image/jpeg, application/pdf"
                    onChange={(e) => {
                      !record.disabledRow &&
                        this.handleAdd(e.target.files[0], arrayId);
                    }}
                  />
                </>
              )}
            </Form.Item>
            <span className={fileName ? "" : "color-red"}>
              {fileName ? (
                <Text
                  onClick={() => {
                    this.modalShowFileCreate(
                      dataTalbeUploads[arrayId].file,
                      "เอกสาร"
                    );
                  }}
                  style={{ cursor: "pointer" }}
                  className="btn-show-fileuploads"
                >
                  ดูไฟล์อัปโหลด
                </Text>
              ) : (
                <span id={"showTextUplodas" + arrayId}>
                  {/* กรุณาเลือก อัปโหลดรูปภาพหรือไฟล์ */}
                </span>
              )}
            </span>
          </>
        )}
      </>
    );
  };

  showMoreFileUploads = (arrayId, uploadFile) => {
    const { formRef } = this.props;
    const { dataTalbeUploads, dataTalbeUploadsDocument, checkModal } =
      this.state;

    console.log("showMoreFileUploads" + arrayId);
    if (dataTalbeUploads[arrayId]?.studyFilePath) {
      console.log("showMoreFileUploads filepath");
      return (
        <Text
          onClick={() => {
            this.modalShowFileCreate2(
              dataTalbeUploads[arrayId],
              "เอกสาร",
              arrayId
            );
          }}
          style={{ cursor: "pointer" }}
          className="btn-show-fileuploads"
        >
          ดูไฟล์เอกสารแนบ
        </Text>
      );
    } else {
      console.log("showMoreFileUploads no studyfilepath");
      return (
        <Text
          onClick={() => {
            this.modalShowFileCreate2(
              dataTalbeUploads[arrayId],
              "เอกสาร",
              arrayId
            );
          }}
          style={{ cursor: "pointer" }}
          className="btn-show-fileuploads"
        >
          ดูไฟล์เอกสารแนบ
        </Text>
      );
    }
  };

  handleAdd = async (images, arrayId) => {
    const { dataTalbeUploads, reqAttachDayStatus } = this.state;
    console.log("value file changed");

    if (images) {
      const isLt2M = images.size / 1024 / 1024 < 20;
      console.log("out if file", images);
      if (
        images.type == "image/jpeg" ||
        images.type == "application/pdf" ||
        images.type == "image/png"
      ) {
        console.log("in if file", images);
        if (!isLt2M) {
          console.log("in if file 2", images);
          message.error("ไฟล์ขนาดใหญ่เกิน 20MB กรุณาระบุ ไฟล์ใหม่อีกครั้ง");
          let dataSourceitems = [...this.state.dataTalbeUploads];
          let item = { ...dataTalbeUploads[arrayId] };
          item = {
            studyLearnTerm: item.studyLearnTerm,
            studyLearnYear: item.studyLearnYear,
            studyLearnGrade: item.studyLearnGrade,
            studyLearnGPAX: item.studyLearnGPAX,
            createdAt: item.createdAt,
            studyLearnRemark: item.studyLearnRemark,
            disabledRow: item.disabledRow,
            isShowEditButton: item.isShowEditButton,
            isShowSaveButton: item.isShowSaveButton,
            isValidate: item.isValidate,
            isNew: item.isNew,
            file: null,
          };
          dataSourceitems[arrayId] = item;

          await this.setState(
            {
              dataTalbeUploads: dataSourceitems,
            },
            () => {
              // this.cllBackSetValueOrganizatuions()
            }
          );
        } else {
          console.log("in if file 3", images);
          let dataSourceitems = [...this.state.dataTalbeUploads];
          let item = { ...dataTalbeUploads[arrayId] };
          item = {
            studyLearnTerm: item.studyLearnTerm,
            studyLearnYear: item.studyLearnYear,
            studyLearnGrade: item.studyLearnGrade,
            studyLearnGPAX: item.studyLearnGPAX,
            createdAt: item.createdAt,
            studyLearnRemark: item.studyLearnRemark,
            disabledRow: item.disabledRow,
            isShowEditButton: item.isShowEditButton,
            isShowSaveButton: item.isShowSaveButton,
            isValidate: item.isValidate,
            isNew: item.isNew,
            file: images,
          };
          dataSourceitems[arrayId] = item;

          this.onChangeValueForm(arrayId, images, "file");

          console.log("studyRecord dataSourceitems ", dataSourceitems);

          await this.setState(
            {
              dataTalbeUploads: dataSourceitems,
            },
            () => {
              // this.cllBackSetValueOrganizatuions()
            }
          );

          const fieldsHandle = this.props.propFormInput.getFieldsValue();
          //const { studyRecord } = fields
          console.log("studyRecord fieldsupload", fieldsHandle);
        }
      } else {
        console.log("else out if file", images);
        alertMessage("กรุณาแนบไฟล์ที่เป็นนามสกุล .jpg, .png หรือ .pdf");
      }
    }
  };

  onClickToNewTab = (typeFile) => {
    const { linkNewTab } = this.state;

    console.log("onClickToNewTab linkNewTab", linkNewTab);
    if (typeFile !== "application/pdf") {
      var win = window.open();
      win.document.write(
        '<div style="margin:0 auto; width:900px; max-width:900px" align="center"><img src="' +
          linkNewTab +
          '" style="max-width:100%;height:100%"/></div>'
      );
    } else {
      var win = window.open();
      win.document.write(
        '<iframe src="' +
          linkNewTab +
          '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
      );
    }
  };

  modalShowFileCreate2 = async (dataFile, title, arrayId) => {
    // var url = URL.createObjectURL(dataFile)

    console.log("DATAFILE VIEW", dataFile);
    const reader = new FileReader();
    if (dataFile.studyFileType !== "application/pdf") {
      //  reader.readAsDataURL(dataFile)
      //  reader.onloadend = async (e) => {
      //      var dataURL = reader.result;
      //      await this.setState({
      //          linkNewTab: dataURL
      //      })

      Modal.info({
        className: "modalFickIcons",
        title: "ไฟล์อัปโหลดเอกสารแนบ",
        width: "1000px",
        content: (
          <div>
            <hr></hr>
            <div className="mt-4">
              <Row gutter={16} type="flex" justify="left" align="top">
                <Col
                  span={10}
                  className="mb-3 block_show_file"
                  style={{ display: "block" }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "200px",
                      padding: "10px 55px",
                    }}
                    align="center"
                    className="block-show-image-modal"
                  >
                    <img
                      src={checkLinkURL() + dataFile.studyFilePath}
                      style={{ height: "100%" }}
                    />
                    <a
                      onClick={() =>
                        this.onClickToNewTab2(dataFile.studyFileType, arrayId)
                      }
                      className="icons-show-images"
                    >
                      <Icon type="eye" style={{ color: "#fff" }} />
                    </a>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        ),
        okText: "ปิด",
        onOk() {},
      });
    } else {
      //  reader.readAsDataURL(dataFile)
      //  reader.onloadend = async (e) => {
      //      var dataURL = reader.result;
      //      await this.setState({
      //          linkNewTab: dataURL
      //      })

      Modal.info({
        className: "modalFickIcons",
        title: "ไฟล์อัปโหลดเอกสารแนบ",
        width: "1000px",
        content: (
          <div>
            <hr></hr>
            <div className="mt-4">
              <Row gutter={16} type="flex" justify="left" align="top">
                <Col
                  span={10}
                  className="mb-3 block_show_file"
                  style={{ display: "block" }}
                >
                  <div
                    style={{ width: "100%", height: "200px" }}
                    align="center"
                    className="block-show-image-modal"
                  >
                    <iframe
                      style={{ opacity: "0", height: "0" }}
                      style={{ display: "none" }}
                    ></iframe>
                    <a
                      onClick={() =>
                        this.onClickToNewTab2(dataFile.studyFileType, arrayId)
                      }
                      className="color-white"
                    >
                      <Icon type="file-pdf" />
                      <br></br>
                      ดูไฟล์ PDF
                    </a>
                    <br></br>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        ),
        okText: "ปิด",
        onOk() {},
      });
    }
  };
  onClickToNewTab2 = (typeFile, arrayId) => {
    const { detailForm } = this.props;
    //const { linkNewTab} = this.state
    console.log("onClickToNewTab2");
    console.log("onClickToNewTab2 typeFile", typeFile);

    if (typeFile !== "application/pdf") {
      console.log("onClickToNewTab2 non pdf");
      var win = window.open();
      win.document.write(
        '<div style="margin:0 auto; width:900px; max-width:900px" align="center"><img src="' +
          checkLinkURL() +
          detailForm?.studyLearnRecord[arrayId]?.studyFilePath +
          '" style="height:100%"/></div>'
      );
    } else {
      console.log("onClickToNewTab2 pdf");
      var win = window.open();
      win.document.write(
        '<iframe src="' +
          checkLinkURL() +
          detailForm?.studyLearnRecord[arrayId]?.studyFilePath +
          '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
      );
    }
  };

  modalShowFileCreate = async (dataFile, title) => {
    const { linkNewTab } = this.state;
    var url = URL.createObjectURL(dataFile);
    const reader = new FileReader();

    console.log("modalShowFileCreate", dataFile.type);

    if (dataFile.type !== "application/pdf") {
      reader.readAsDataURL(dataFile);
      reader.onloadend = async (e) => {
        var dataURL = reader.result;
        console.log("linkNewTab dataURL", dataURL);
        await this.setState({
          linkNewTab: dataURL,
        });

        Modal.info({
          className: "modalFickIcons pt-4",
          title: "ไฟล์อัปโหลดเอกสารแนบ",
          width: "800px",
          content: (
            <div>
              <hr></hr>
              <div className="pt-4">
                <Row gutter={16} type="flex" justify="left" align="top">
                  <Col span={8} style={{ display: "block" }}>
                    <div
                      style={{
                        width: "100%",
                        height: "200px",
                        padding: "10px 55px",
                      }}
                      align="center"
                      className="block-show-image-modal"
                    >
                      <img src={dataURL} className="zoom-in" />
                      <a
                        onClick={() => this.onClickToNewTab(dataFile.type)}
                        className="icons-delect-images"
                      >
                        <Icon type="eye" style={{ color: "#fff" }} />
                      </a>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          ),
          okText: "ปิด",
          onOk() {},
        });
      };
    } else {
      console.log("modalShowFileCreate pdf", dataFile.type);

      reader.readAsDataURL(dataFile);
      reader.onloadend = async (e) => {
        var dataURL = reader.result;
        await this.setState({
          linkNewTab: dataURL,
        });
        Modal.info({
          className: "modalFickIcons pt-4",
          title: "ไฟล์อัปโหลดเอกสารแนบ",
          width: "800px",
          content: (
            <div>
              <hr></hr>
              <div className="pt-4">
                <Row gutter={16} type="flex" justify="left" align="top">
                  <Col span={8} style={{ display: "block" }}>
                    <div
                      style={{ width: "100%", height: "200px" }}
                      align="center"
                      className="block-show-image-modal"
                    >
                      <a
                        onClick={() => this.onClickToNewTab(dataFile.type)}
                        className="color-white"
                      >
                        <Icon type="file-pdf" />
                        <br></br>
                        ดูไฟล์ PDF
                      </a>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          ),
          okText: "ปิด",
          onOk() {},
        });
      };
    }
  };

  modalShowFileDatabase = async (dataFile) => {
    console.log("modalShowFileDatabase", dataFile);

    if (dataFile.fileType !== "application/pdf") {
      Modal.info({
        className: "modalFickIcons pt-4",
        title: "ไฟล์อัปโหลดเอกสารแนบ",
        width: "800px",
        content: (
          <div>
            <hr></hr>
            <div className="pt-4">
              <Row gutter={16} type="flex" justify="left" align="top">
                <Col span={8} style={{ display: "block" }}>
                  <div
                    style={{
                      width: "100%",
                      height: "200px",
                      padding: "10px 55px",
                    }}
                    align="center"
                    className="block-show-image-modal"
                  >
                    <img
                      src={checkLinkURL() + dataFile.file}
                      className="zoom-in"
                    />
                    <a
                      onClick={() =>
                        this.onClickToNewTabDatabase(
                          dataFile.fileType,
                          checkLinkURL() + dataFile.file
                        )
                      }
                      className="icons-delect-images"
                    >
                      <Icon type="eye" style={{ color: "#fff" }} />
                    </a>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        ),
        okText: "ปิด",
        onOk() {},
      });
    } else {
      Modal.info({
        className: "modalFickIcons pt-4",
        title: "ไฟล์อัปโหลดเอกสารแนบ",
        width: "800px",
        content: (
          <div>
            <hr></hr>
            <div className="pt-4">
              <Row gutter={16} type="flex" justify="left" align="top">
                <Col span={8} style={{ display: "block" }}>
                  <div
                    style={{ width: "100%", height: "200px" }}
                    align="center"
                    className="block-show-image-modal"
                  >
                    <a
                      onClick={() =>
                        this.onClickToNewTabDatabase(
                          dataFile.fileType,
                          checkLinkURL() + dataFile.file
                        )
                      }
                      className="color-white"
                    >
                      <Icon type="file-pdf" />
                      <br></br>
                      ดูไฟล์ PDF
                    </a>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        ),
        okText: "ปิด",
        onOk() {},
      });
    }
  };

  destroyArrayDataUploads = async (arrayId, StudyLearnRecordId = null) => {
    const { form, onChangeDeletedStudyLearnRecord } = this.props;
    const { dataTalbeUploads } = this.state;
    var arrayDataSource = [...this.state.dataTalbeUploads];
    arrayDataSource.splice(arrayId, 1);

    //await this.hideModalConfirm();
    console.log("arrayDataSource before", arrayDataSource);
    console.log("destroyArray", arrayId);
    if (StudyLearnRecordId) {
      onChangeDeletedStudyLearnRecord(StudyLearnRecordId);
    }
    await this.setState(
      {
        dataTalbeUploads: arrayDataSource,
        // dataTalbeLength: lengthData
      },
      async () => {
        await this.props.onTableChange(arrayDataSource);
        let lengthData = arrayDataSource.length;
        await this.setState({
          dataTalbeLength: lengthData,
        });

        const fieldsBeforeMap = this.props.propFormInput.getFieldsValue();
        //const { studyRecord } = fields
        console.log("studyRecord fieldsBefore map", fieldsBeforeMap);

        console.log("arrayDataSource.file", arrayDataSource);
        arrayDataSource.map(async (valuesTable, keysTable) => {
          let studyLearnTerm = `studyLearnTerm${keysTable}`;
          let studyLearnYear = `studyLearnYear${keysTable}`;
          let studyLearnGrade = `studyLearnGrade${keysTable}`;
          let studyLearnGPAX = `studyLearnGPAX${keysTable}`;
          let createdAt = `createdAt${keysTable}`;
          let studyLearnRemark = `studyLearnRemark${keysTable}`;
          let file = `file${keysTable}`;
          let studyFileName = `studyFileName${keysTable}`;



          const fieldsBefore = this.props.propFormInput.getFieldsValue();
          //const { studyRecord } = fields
          console.log("studyRecord fieldsBefore2", fieldsBefore);

          await this.props.propFormInput.setFieldsValue({
            [studyLearnTerm]: valuesTable.studyLearnTerm,
            [studyLearnYear]: valuesTable.studyLearnYear,
            [studyLearnGrade]: valuesTable.studyLearnGrade,
            [studyLearnGPAX]: valuesTable.studyLearnGPAX,
            [createdAt]: valuesTable.createdAt
              ? moment(valuesTable.createdAt)
              : null,
            [studyLearnRemark]: valuesTable.studyLearnRemark,
            //[file]: fieldsBefore.file,
            [studyFileName]: valuesTable.studyFileName,
          });
          // console.log("arrayDataSource valuesTable.file", valuesTable);
          // console.log("arrayDataSource this.props.propFormInput", this.props.propFormInput);
          const fieldsX = this.props.propFormInput.getFieldsValue();
          //const { studyRecord } = fields
          console.log("studyRecord map", fieldsX);
        });
        const fields = this.props.propFormInput.getFieldsValue();
        //const { studyRecord } = fields
        console.log("studyRecord", fields);
        console.log("arrayDataSource after", arrayDataSource);
      }
    );
  };

  destroyArrayDataUploadsRecord = async () => {
    const { form, onChangeDeletedStudyLearnRecord } = this.props;
    const { dataTalbeUploads, destroyArrayId, destroyStudyLearnRecordId } =
      this.state;

    const fieldsBeforeMap1 = this.props.propFormInput.getFieldsValue();
    //const { studyRecord } = fields
    console.log(
      "studyRecord fieldsBefore map record initial",
      fieldsBeforeMap1
    );

    var arrayDataSource = [...this.state.dataTalbeUploads];

    console.log("arrayDataSource before eiei", arrayDataSource);
    arrayDataSource.splice(destroyArrayId, 1);

    // console.log("destroyArrayDataUploadsRecord destroyArrayId", destroyArrayId);
    // console.log(
    //   "destroyArrayDataUploadsRecord destroyStudyLearnRecordId",
    //   destroyStudyLearnRecordId
    // );

    console.log("arrayDataSource before", arrayDataSource);

    const fieldsBeforeMap2 = this.props.propFormInput.getFieldsValue();
    //const { studyRecord } = fields
    console.log(
      "studyRecord fieldsBefore map record initial 2",
      fieldsBeforeMap2
    );

    await this.hideModalConfirm();
    console.log("destroyArray", destroyArrayId);
    if (destroyStudyLearnRecordId) {
      onChangeDeletedStudyLearnRecord(destroyStudyLearnRecordId);
    }

    const fieldsBeforeMap25 = this.props.propFormInput.getFieldsValue();
    //const { studyRecord } = fields
    console.log(
      "studyRecord fieldsBefore map record initial 2.5",
      fieldsBeforeMap25
    );

    await this.setState(
      {
        dataTalbeUploads: arrayDataSource,
        // dataTalbeLength: lengthData
      },
      async () => {
        const fieldsBeforeMap3 = this.props.propFormInput.getFieldsValue();
        //const { studyRecord } = fields
        console.log(
          "studyRecord fieldsBefore map record initial 3",
          fieldsBeforeMap3
        );

        await this.props.onTableChange(arrayDataSource);
        let lengthData = arrayDataSource.length;
        await this.setState({
          dataTalbeLength: lengthData,
        });

        console.log(
          " studyRecord fieldsBefore map record arrayDataSource",
          arrayDataSource
        );

        arrayDataSource.map(async (valuesTable, keysTable) => {
          if (!valuesTable.createdAt) {
            let fileTemp = `file${keysTable}`;
            await this.props.propFormInput.setFieldsValue({
              [fileTemp]: fileTemp,
            });
            console.log(" studyRecord fieldsBefore map keysTable", keysTable);
            console.log(
              " studyRecord fieldsBefore map record valuesTable.file",
              fileTemp
            );
          } else {
            console.log(
              " studyRecord fieldsBefore map keysTable have data",
              keysTable
            );
          }
        });

        const fieldsBeforeMap = this.props.propFormInput.getFieldsValue();
        //const { studyRecord } = fields
        console.log("studyRecord fieldsBefore map record", fieldsBeforeMap);

        console.log("arrayDataSource.file", arrayDataSource);
        arrayDataSource.map(async (valuesTable, keysTable) => {
          let studyLearnTerm = `studyLearnTerm${keysTable}`;
          let studyLearnYear = `studyLearnYear${keysTable}`;
          let studyLearnGrade = `studyLearnGrade${keysTable}`;
          let studyLearnGPAX = `studyLearnGPAX${keysTable}`;
          let createdAt = `createdAt${keysTable}`;
          let studyLearnRemark = `studyLearnRemark${keysTable}`;
          let file = `file${keysTable}`;
          let studyFileName = `studyFileName${keysTable}`;
          let  disabledRow = `disabledRow${keysTable}`;
          let  isShowEditButton = `isShowEditButton${keysTable}`;
          let  isShowSaveButton = `isShowSaveButton${keysTable}`;
          let isValidate = `isValidate${keysTable}`;
          let  isNew= `isNew${keysTable}`;

          const fieldsBefore = this.props.propFormInput.getFieldsValue();
          //const { studyRecord } = fields
          console.log("studyRecord fieldsBefore2 record", fieldsBefore);

          await this.props.propFormInput.setFieldsValue({
            [studyLearnTerm]: valuesTable.studyLearnTerm,
            [studyLearnYear]: valuesTable.studyLearnYear,
            [studyLearnGrade]: valuesTable.studyLearnGrade,
            [studyLearnGPAX]: valuesTable.studyLearnGPAX,
            [createdAt]: valuesTable.createdAt
              ? moment(valuesTable.createdAt)
              : null,
            [studyLearnRemark]: valuesTable.studyLearnRemark,
            //[file]: valuesTable.file,
            [studyFileName]: valuesTable.studyFileName,
            [disabledRow]: valuesTable.disabledRow,
            [isShowEditButton]: valuesTable.isShowEditButton,
            [isShowEditButton]: valuesTable.isShowEditButton,
            [isShowSaveButton]: valuesTable.isShowSaveButton,
            [isValidate]: valuesTable.isValidate,
            [isNew]: valuesTable.isNew,

          });
          const fieldsX = this.props.propFormInput.getFieldsValue();
          //const { studyRecord } = fields
          console.log("studyRecord map record", fieldsX);
        });
        console.log(
          "arrayDataSource this.props.propFormInput",
          this.props.propFormInput
        );
        console.log("arrayDataSource after", arrayDataSource);
      }
    );
  };

  onChangeValueForm = async (arrayId, values, name) => {
    const { dataTalbeUploads } = this.state;
    let dataSourceitems = [...this.state.dataTalbeUploads];
    let item = { ...dataSourceitems[arrayId] };


  console.log("item onchange",item)
    if (name == "studyLearnTerm") {
      item.studyLearnTerm = values.target.value;
    } else if (name == "studyLearnYear") {
      item.studyLearnYear = values.target.value;
    } else if (name == "studyLearnGrade") {
      item.studyLearnGrade = values.target.value;
    } else if (name == "studyLearnGPAX") {
      item.studyLearnGPAX = values.target.value;
    } else if (name == "studyLearnRemark") {
      item.studyLearnRemark = values.target.value;
    } else if (name == "createdAt") {
      item.createdAt = values;
    } else if (name == "file") {
      item.file = values;
    } else if (name == "validate") {
      item.isValidate = values;
    }

    dataSourceitems[arrayId] = item;

    console.log("dataSourceitems",dataSourceitems)
    await this.setState(
      {
        dataTalbeUploads: dataSourceitems,
      },
      async () => {
        // await this.setSummary()
        // this.cllBackSetValueContactNumber()
      }
    );

    this.props.onTableChange(dataSourceitems);
  };

  showDataInputUploads = async () => {
    const { formRef, detailForm, propFormInput } = this.props;
    const { dataTalbeUploads, studyLearnRecord } = this.state;

    console.log("propFormInput upload", propFormInput.getFieldsValue());

    const rows = {
      // docId: "",
      studyLearnTerm: null,
      studyLearnYear: null,
      studyLearnGrade: null,
      studyLearnGPAX: null,
      createdAt: null,
      studyLearnRemark: null,
      file: null,
      isNew: true,
      isShowEditButton: false,
      isShowSaveButton: true,
      isValidate: false,
      disabledRow: false,
    };

    await this.setState(
      (prevState) => ({
        dataTalbeUploads: [...prevState.dataTalbeUploads, rows],
        disabledAdd: true 
      }),
      async () => {
        let lengthData = dataTalbeUploads.length + 1;
        await this.setState({
          dataTalbeLength: lengthData,
        });
        // const fields = formRef.current.getFieldsValue()
        // const { studyLearnRecord } = fields

        console.log("dataTalbeUploads", dataTalbeUploads);

        // arrayDataSource.map(async (valuesTable, keysTable) => {
        //   let studyLearnTerm = `studyLearnTerm${keysTable}`;
        //   let studyLearnYear = `studyLearnYear${keysTable}`;
        //   let studyLearnGrade = `studyLearnGrade${keysTable}`;
        //   let studyLearnGPAX = `studyLearnGPAX${keysTable}`;
        //   let createdAt = `createdAt${keysTable}`;
        //   let studyLearnRemark = `studyLearnRemark${keysTable}`;
        //   let file = `file${keysTable}`;
        //   let studyFileName = `studyFileName${keysTable}`;

        //   await this.props.propFormInput.setFieldsValue({
        //     [studyLearnTerm]: valuesTable.studyLearnTerm,
        //     [studyLearnYear]: valuesTable.studyLearnYear,
        //     [studyLearnGrade]: valuesTable.studyLearnGrade,
        //     [studyLearnGPAX]: valuesTable.studyLearnGPAX,
        //     [createdAt]: valuesTable.createdAt
        //       ? moment(valuesTable.createdAt)
        //       : null,
        //     [studyLearnRemark]: valuesTable.studyLearnRemark,
        //     [file]: valuesTable.file,
        //     [studyFileName]: valuesTable.studyFileName,
        //   });
        //   console.log("arrayDataSource valuesTable.file", valuesTable);
        //   console.log("arrayDataSource this.props.propFormInput", this.props.propFormInput);
        // });

        //  console.log("studyLearnRecord fields",studyLearnRecord)
        //  console.log("dataTalbeUploads.lengt",dataTalbeUploads.lengt)
        //     await Object.assign(studyLearnRecord[dataTalbeUploads.length],
        //        {
        //          //  studyScholarshipDetailId: null,
        //          //studyScholarshipDetailSort: dataTalbestudyScholarshipDetail.length+1,
        //          studyLearnTerm: "",
        //          studyLearnYear: "",
        //          studyLearnGrade: null,
        //          studyLearnGPAX: null,
        //          createAt:"",
        //          studyLearnRemark: ""
        //        }
        //     )
        // await formRef.current.setFieldsValue({ studyLearnRecord })
      }
    );
  };
  // onSubmit = async (values) =>{
  // 	const { data, submitToSend, valueConfirm } = this.props
  //       await this.setState({
  // 		preLoadOnsubmit: true
  // 	})
  // 	valueConfirm.ModalNoteApprove = ''

  //       await submitToSend(valueConfirm)
  // }

  submitFormDelete = async (e) => {
    const { data, submitToSend, valueConfirm } = this.props;
    const { form, client } = this.props;

    //     e.preventDefault()
    // form.validateFields(async (err, values) => {
    // 	// alert('xxxx')
    // 	if (!err) {
    // 		valueConfirm.ModalNoteApprove = values.noteApprove ? values.noteApprove : ''
    // 		// console.log('valueConfirm',valueConfirm)
    // 		await submitToSend(valueConfirm)
    // 	}
    //     })

    await this.destroyArrayDataUploadsRecord();
  };

  closeModal = async () => {
    this.hideModalConfirm();
  };

  // fetchDropDownstudyLeaveYear = async () => {

  //   const { client, location, match } = this.props;
  //   const { offset, limit, detailForm,dropDownYear } = this.state;
  //   let dropDownRetrue = []

  //   console.log("fetchDropDownstudyLeaveYear")
  //     const { data, errors } = await client.query({
  //       query: Queries.dropDownstudyLeaveYear,
  //       variables: {
  //         studyLeaveRequestId: match.url.split("/")[4],
  //       },
  //     });

  //     await data.dropDownstudyLeaveYear.map((values, keys) => {
  //       dropDownRetrue.push({
  //         value: values.value,
  //         label: values.label,
  //       });
  //     });

  //     await this.setState({
  //       [dropDownYear]: dropDownRetrue,
  //     });
  //     // return data.fetchProfile

  //     console.log("FETCH dropDownstudyLeaveYear", data.dropDownstudyLeaveYear);
  //     console.log("FETCH dropDownstudyLeaveYear retrue:", dropDownRetrue);

  // };

  handleEditRow = async (arrayId) => {
    const { dataTalbeUploads } = this.state;
    const { propFormInput } = this.props;

    const mergeData = dataTalbeUploads.map((obj, _index) => ({
      ...obj,
      //...formRef.current.getFieldsValue()?.studyScholarship.studyScholarshipDetail[_index],
      // studyExtendRound: _index + 1,
      // studyExtendSort: _index + 1,
      disabledRow:
        _index == arrayId ? true : obj.isValidate == false ? false : true,
      isShowEditButton:
        _index == arrayId ? true : obj.isValidate == false ? false : true,
      isShowSaveButton:
        _index == arrayId ? false : obj.isValidate == false ? true : false,
      isValidate:
        _index == arrayId ? true : obj.isValidate == false ? false : true,
        
    }));

    this.onChangeValueForm(arrayId, true, "validate")
    
    //console.log("row extend handle add", row);

    console.log("mergeData upload", mergeData);

    await this.setState({ dataTalbeUploads: mergeData });

    // propFormInput.setFieldsValue({
    //   studylea : mergeData
    // });

    let enableAddButton = true;
    mergeData.map((resultObj, _index) => {
      if (!resultObj.isValidate) {
        enableAddButton = false;
      }
    });

    if (enableAddButton) {
      await this.setState({ disabledAdd: false });
    } else {
      await this.setState({ disabledAdd: true });
    }
  };

  checkBeforeAddRow = async (arrayId) => {
    const { dataTalbeUploads } = this.state;
    const { propFormInput } = this.props;
    console.log("checkBeforeAddRow arrayId", arrayId);
    console.log(
      "checkBeforeAddRow propFormInput.getFieldsValue()",
      propFormInput.getFieldsValue()
    );
    const tableValue = dataTalbeUploads;
    // .map((obj, _index) => ({
    //   ...obj,
    //   ...propFormInput.getFieldsValue()?.studyLearnRecord[_index],
    // }));

    await this.setState({ disabledAdd: true });

    console.log("tableValue", tableValue);
    let lastRowValue = null;
    if (arrayId == "new") {
      console.log("arrayId = -1", arrayId);
      lastRowValue = tableValue[dataTalbeUploads.length - 1];
    } else {
      console.log("arrayId != -1");
      lastRowValue = tableValue[arrayId];
    }

    console.log("lastRowValue", lastRowValue);

    let errorValue = false;
    let dupDateErrorReturnDate = false;
    let dupDateErrorReturnDocument = false;

    let errorYear = false;
    console.log("errorYear studyLearnRecord", dataTalbeUploads);
    console.log("errorYear before", errorYear);
    if (dataTalbeUploads.length !== 0) {
      console.log("errorYear studyLearnRecord length hi");

      var valueArr = dataTalbeUploads.map(function (item) {
        return {
          studyLearnYear: item.studyLearnYear,
          studyLearnTerm: item.studyLearnTerm,
        };
      });

      var checkDuplicateArray = valueArr.filter(
        (v, i, a) =>
          a.findIndex(
            (t) =>
              t.studyLearnYear === v.studyLearnYear &&
              t.studyLearnTerm === v.studyLearnTerm
          ) === i
      );
          }
    if (
      !lastRowValue.studyLearnYear ||
      lastRowValue.studyLearnTerm == "" ||
      lastRowValue.studyLearnGPAX == "" ||
      lastRowValue.studyLearnGrade == "" 
      // ||
      // !lastRowValue.file
    ) {
      errorValue = true;
      //TODO : specify empty field name in modal.error
      Modal.error({
        className: "modalFickIcons",
        title: "เพิ่มข้อมูลผลการศึกษาไม่สำเร็จ",
        width: "600px",
        content: <h3 className="mt-3">กรุณาระบุข้อมูลให้ครบถ้วน</h3>,
        okText: "ปิด",
        onOk() {},
      });
    }
    else if (checkDuplicateArray.length != dataTalbeUploads.length) {
      console.log("isDuplicate hi");
      Modal.error({
        className: "modalFickIcons",
        title: "เพิ่มข้อมูลผลการศึกษาไม่สำเร็จ",
        width: "600px",
        content: (
          <h3 className="mt-3">
            ไม่สามารถบันทึกภาคการศึกษาและปีการศึกษาซ้ำได้
          </h3>
        ),
        okText: "ปิด",
        onOk() {},
      });
    }
    else {
      let arrayCheckDup = null;

      if (arrayId == "new") {
        arrayCheckDup = tableValue.slice(0, -1);
        console.log("table value slice", arrayCheckDup);
      } else {
        arrayCheckDup = tableValue;
      }

      // arrayCheckDup.map((values, keys) => {
      //   console.log("keys", keys.toString());
      //   console.log("arrayId before checkdate", arrayId.toString());

      //   if (keys != arrayId && values.isValidate) {
      //     if (
      //       moment(lastRowValue.studyLeaveReturnDate).format("YYYY/MM/DD") == moment(values.studyLeaveReturnDate).format("YYYY/MM/DD")
      //     ) {
      //       dupDateErrorReturnDate = true;
      //     }
      //     else if(lastRowValue.studyLeaveReturnDocument == values.studyLeaveReturnDocument){
      //       dupDateErrorReturnDocument = true;
      //     }

      //   }
      // });

      
    }

    if (!errorValue && !dupDateErrorReturnDate && !dupDateErrorReturnDocument && checkDuplicateArray.length == dataTalbeUploads.length) {
      if (arrayId == "new") {
        console.log("handleaddrow");
        this.showDataInputUploads();
      } else {
        console.log("handleEditRow");
        this.handleEditRow(arrayId);
      }
    }
  };

  async componentDidMount() {
    const { match, detailForm } = this.props;
    const { columns, preLoadOnsubmit, dataTalbeUploads, dataTalbeLength } =
      this.state;

    // await this.setState({
    //    dataTalbeLength: detailForm?.studyLearnRecord.length+1,
    //    dataTalbeUploads: detailForm?.studyLearnRecord
    //  });

    if (detailForm.studyLearnRecord) {
      const mergeData = detailForm?.studyLearnRecord.map((obj, _index) => ({
        ...obj,
        disabledRow: true,
        //isShowEditButton: true,
        //isShowSaveButton: false,
        isValidate: true,
      }));

      await this.setState({
        dataTalbeLength: detailForm?.studyLearnRecord.length,
        dataTalbeUploads: mergeData,
        loading: false,
      });
    } else {
      await this.setState({
        loading: false,
      });
    }
    //await this.fetchDropDownstudyLeaveYear();
    //console.log("detailForm?.studyLearnRecord.length",detailForm?.studyLearnRecord.length)
  }

  enableToEdit = async (arrayId, data) => {
    console.log("hi Edit Row");
    const { dataTalbeUploads } = this.state;
    const { propFormInput } = this.props;

    const mergeData = dataTalbeUploads.map((obj, _index) => ({
      ...obj,
     // ...formRef.current.getFieldsValue()?.studyScholarship.studyScholarshipDetail[_index],
      isShowSaveButton:
        _index == arrayId ? true : obj.isValidate == false ? true : false,
      isShowEditButton:
        _index == arrayId ? false : obj.isValidate == false ? false : true,
      disabledRow:
        _index == arrayId ? false : obj.isValidate == false ? false : true,
      isValidate:
        _index == arrayId ? false : obj.isValidate == false ? false : true,
    }));

    this.onChangeValueForm(arrayId, false, "validate")

    await this.setState({ dataTalbeUploads: mergeData });
    // setRow(mergeData);
    // formRef.current.setFieldsValue({
    //   studyScholarship:{
    //     studyScholarshipDetail : mergeData
    //   }  
    // });

    
    await this.setState({ disabledAdd: true });
  };

  render() {
    const { match, detailForm, dropDownYear } = this.props;
    const { getFieldDecorator } = this.props.propFormInput;
    const {
      columns,
      preLoadOnsubmit,
      ModalConfirmFormTitle,
      ModalConfirmFormSubTitle,
      ModalConfirmFormShowModal,
      ModalConfirmFormBtnOk,
      ModalConfirmFormBtnCancel,
      ModalConfirmFormValue,
      dataTalbeUploads,
      dataTalbeLength,
      ModalConfirmFormSubmitToSend,
      ModalFormTextArea,
      disabledAdd,
    } = this.state;

    console.log("dataTalbeUploads logs", dataTalbeUploads);

    return (
      <Row gutter={16} type="flex" justify="left" align="top">
        <Col xs={24} md={24} className="pt-0">
          <strong className="color-red">ผลการศึกษา</strong>
        </Col>
        {/* <ModalConfirmForm
          title={ModalConfirmFormTitle}
          subtitle={ModalConfirmFormSubTitle}
          showModal={ModalConfirmFormShowModal}
          btnOk={ModalConfirmFormBtnOk}
          btnCancel={ModalConfirmFormBtnCancel}
          submitToSend={ModalConfirmFormSubmitToSend}
          hideModal={this.hideModalConfirm}
          valueConfirm={ModalConfirmFormValue}
        /> */}

        <Modal
          destroyOnClose={true}
          visible={ModalConfirmFormShowModal}
          maskClosable={false}
          title="ท่านต้องการลบข้อมูล?"
          // onOk={ () =>{
          //     this.onSubmit()
          // }}
          onCancel={() => {
            this.closeModal();
          }}
          width={600}
          okText={"ยืนยัน"}
          cancelText={"ยกเลิก"}
          footer={null}
          className={ModalFormTextArea ? "showTextArrea" : ""}
        >
          {ModalFormTextArea ? (
            <>
              {
                //subtitle &&
                <span>{/* {subtitle} */}</span>
              }

              <Form
              //ref={this.formRef}
              >
                <Row gutter={16} type="flex" justify="left" align="top">
                  <Col xs={24} md={24}>
                    <Form.Item label={"หมายเหตุ"}>
                      {getFieldDecorator("noteApprove", {
                        initialValue: "",
                        rules: [
                          {
                            //required: ModalFormTextAreaRequie,
                            message: "กรุณากรอก หมายเหตุ",
                          },
                        ],
                      })(<TextArea rows={3} className="block-news" />)}
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={24} align={"right"}>
                    <Button
                      type="primary"
                      className="mt-1 mr-3 btn-white-red"
                      //	disabled={ preLoadOnsubmit }
                      // onClick={ this.searchForm }
                      onClick={async () => this.closeModal()}
                    >
                      ยกเลิก
                    </Button>

                    <Button
                      type="primary "
                      className="mt-1 color-white"
                      htmlType="submit"
                      //disabled={ preLoadOnsubmit }
                      onClick={this.submitFormDelete()}
                    >
                      ยืนยัน
                    </Button>
                  </Col>
                </Row>
              </Form>
            </>
          ) : (
            <Form
            //ref={this.formRef}
            >
              <Row gutter={16} type="flex" justify="left" align="top">
                {
                  // subtitle &&
                  // <Col xs={24} md={24} >
                  // 	<span>
                  // 		{subtitle}
                  // 	</span>
                  // </Col>
                }
                <Col xs={24} md={24} align={"right"}>
                  <Button
                    type="primary"
                    className="mt-1 mr-3 btn-white-red"
                    //disabled={ preLoadOnsubmit }
                    // onClick={ this.searchForm }
                    onClick={async () => this.closeModal()}
                  >
                    ยกเลิก
                  </Button>

                  <Button
                    type="primary "
                    className="mt-1 color-white"
                    htmlType="submit"
                    //disabled={ preLoadOnsubmit }
                    // onClick={ this.searchForm }
                    onClick={async () =>
                      //this.onSubmit()
                      this.submitFormDelete()
                    }
                  >
                    ยืนยัน
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Modal>

        <Col xs={24} md={24} align={"right"} className="pt-4">
          {console.log("dataTalbeLength", dataTalbeLength)}
          {console.log("dataTalbeLength upload", dataTalbeUploads)}
          <Table
            columns={columns}
            dataSource={dataTalbeUploads}
            pagination={false}
            className="mb-3"
            bordered
            // rowCount={dataTalbeLength}
            locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
            scroll={{ x: "max-content" }}
            // pagination={{ pageSize: dataTalbeUploads.length }}
          />
          <Button
            style={{ display: "inline-block" }}
            type="primary btn-color-default btn-custom btn-clear color-white"
            className="mt-1 mr-2"
            onClick={() =>
              dataTalbeUploads.lenght > 0
                ? this.checkBeforeAddRow("new")
                : this.showDataInputUploads()
            }
            disabled={disabledAdd ? true : false}
          >
            เพิ่มแถว
          </Button>
        </Col>
        <Col xs={24} md={16}>
                      <ul style={{ listStyle: "none" }} className="p-0">
                        <li>
                        หมายเหตุ
                        </li>
                        <li>
                        - ตัวอย่างการระบุข้อมูลเกรดเฉลี่ย (GPA) / ผลการศึกษา  เช่น 3.28, S, PASS
                        </li>
                        <li>
                        - ตัวอย่างการระบุข้อมูลเกรดเฉลี่ยสะสม (GPAX) / ผลการศึกษา  เช่น 3.28, S, PASS
                        </li>
                        <li>
                        - ต้องมีการกดปุ่มบันทึก แต่ละ record ก่อน จึงจะสามารถเพิ่มข้อมูลหรือยื่นเรื่องได้
                        </li>
                      </ul>
                    </Col>
        
      </Row>
   
    );
  }
}

Tab4.defaultProps = {
  autoFocus: false,
};
Tab4.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedTab4 = Form.create()(Tab4);

export default withApollo(WrappedTab4);
